export default function PullQuote() {
  return (
    <section
      data-testid="pull-quote-section"
      className="py-16 md:py-20 bg-[#efeee9]"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-3xl text-center">
        <p
          className="text-2xl md:text-3xl lg:text-4xl text-[#1a1a1a] leading-snug font-light italic"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          "Optionality is an asset class. Freedom is engineered, not declared."
        </p>
      </div>
    </section>
  );
}
